import script from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPendencyModal.vue?vue&type=style&index=0&id=2d2d2320&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2d2320"]])

export default __exports__